import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useTheme } from "styled-components";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import DogNameCurved from "../../components/DogNameCurved.component";
import PictureInput from "../../components/form/Picture.input";
import api from "../../services/api";
import { useUserStore } from "../../store/useUserStore";
import { PrimaryFitContentButton } from "../../styles/Button.style";
import { MainContainer, RootContainer } from "../../styles/Container.style";
import { Paragraph, Title } from "../../styles/Text";
import { Column, Gap } from "../../styles/Utils";

export default function AddPicturePage() {
  const navigate = useNavigate();
  const [selectedPictures, setSelectedPictures] = useState<(File | string | null)[]>([null, null, null, null]);
  const {
    profile: { imageUrls, dogName },
    setImageUrls,
  } = useUserStore();
  const theme = useTheme();
  const [sumbmitting, setSumbmitting] = useState<boolean>(false);

  useEffect(() => {
    if (imageUrls.length > 0) navigate(routeList.aboutThem);
  });

  const handleSubmission = async () => {
    setSumbmitting(true);
    const formData = new FormData();

    // Loop over the selected images and append each one to the formData
    selectedPictures.forEach((image) => {
      image = image as File | string;
      if (image) {
        formData.append(`files`, image); // Append each image with a unique key
      }
    });

    try {
      const response = await api.addImages(formData);
      if (response.data.imageUrls) {
        mixpanel.track("Onboarding Add Pictures Submit");
        setImageUrls(response.data.imageUrls);
        navigate(routeList.aboutThem);
      }
    } catch (err) {
      console.log("Error adding images", err);
      alert("Error adding images");
    }
    setSumbmitting(false);
  };

  const formValid = selectedPictures.filter((e) => e != null).length > 1;

  return (
    <RootContainer $topSafe={true} $background={theme.color.primaryExtraLight}>
      <Column $alignItem="center" $maxHeight>
        <DogNameCurved dogName={dogName!} color={theme.color.primary} />
        <MainContainer $padding="3rem 1rem 1rem 1rem" $zIndex={1}>
          <Title>{lang.addPicturesPage.title}</Title>
          <Gap $height={1} />
          <Paragraph>{lang.addPicturesPage.message}</Paragraph>
          <Gap $height={1} />
          <PictureInput selectedPictures={selectedPictures} setSelectedPictures={setSelectedPictures} />
        </MainContainer>
        <Gap $height={1.5} />
        <PrimaryFitContentButton type="submit" disabled={!formValid} onClick={handleSubmission}>
          {sumbmitting ? <BeatLoader color={theme.color.tertiaryLight} /> : <span>{lang.buttons.continue}</span>}
        </PrimaryFitContentButton>
      </Column>
    </RootContainer>
  );
}
